<template>
  <div v-if="dialogVisible">
    <el-dialog :title="$t('lang.Button.edit')" :visible.sync="dialogVisible" center> 
      <div class="Form">
        <el-form label-width="180px" style="width: 70%">
          <el-form-item :label="`${$t('lang.ConfigSetting.Rule')}：`" prop="name">
            <el-button type="primary" size="mini" @click="OnOff" v-if="SNAT.enabled">
              {{$t('lang.ConfigSetting.DISABLE')}}
            </el-button>
            <el-button v-else type="danger" size="mini" @click="OnOff" >
              {{$t('lang.ConfigSetting.DEABLE')}}
            </el-button>
          </el-form-item>
          <el-form-item :label="`${$t('lang.firewall.name')}：`">
            <el-input class="Form-Input-Width" size="small" v-model="SNAT.name"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.firewall.protocal')}：`">
            <el-row>
              <el-col :span="24">
                <el-input 
                  @blur="protoBlur" 
                  v-if="protoCustom" 
                  ref='proto' size="mini" 
                  v-model="SNAT.proto" 
                  class="Form-Input-Width"
                  :placeholder="$t('lang.ConfigSetting.pleaseInput')">
                </el-input>
                <el-select
                  v-else
                  :placeholder="$t('lang.ConfigSetting.pleaseChoose')"
                  v-model="SNAT.proto"
                  size="mini"
                  @change="protoChange"
                  class="Form-Input-Width">
                  <el-option v-for="ele in protoOptions" :key="ele.value" :label="ele.label" :value="ele.value"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <span class="redirect-Tips">{{$t('lang.firewall.protocalTips')}}</span>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="`${$t('lang.firewall.sourceArea')}：`">
            <el-select
              :placeholder="$t('lang.ConfigSetting.pleaseChoose')"
              v-model="SNAT.src"
              size="mini"
              class="Form-Input-Width">
              <el-option v-for="ele in SRCOptions" :key="ele.value" :label="ele.label" :value="ele.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.firewall.sourceIp')}：`">
            <select-input :SelectArr="IpList" :SelectValue="SNAT.src_ip" :index="['src_ip']" @GetSelectValue="IpSelectInput" :widths="4"></select-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.firewall.targetArea')}：`">
            <el-select
              :placeholder="$t('lang.ConfigSetting.pleaseChoose')"
              v-model="SNAT.dest"
              size="mini"
              class="Form-Input-Width">
              <el-option v-for="ele in SRCOptions" :key="ele.value" :label="ele.label" :value="ele.value"></el-option>
            </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('lang.firewall.targetIp')}：`">
              <select-input :SelectArr="IpList" :SelectValue="SNAT.dest_ip" :index="['dest_ip']" @GetSelectValue="IpSelectInput" :widths="4"></select-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.firewall.SNATIp')}：`">
              <el-row>
                <el-col :span="24">
                  <select-input :SelectArr="IpList" :SelectValue="SNAT.src_dip" :index="['src_dip']" @GetSelectValue="IpSelectInput" :widths="4"></select-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span class="redirect-Tips">{{$t('lang.firewall.SNATIpTips')}}</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item :label="`${$t('lang.firewall.additonalParameters')}：`">
              <el-row>
                <el-col :span="24">
                  <el-input class="Form-Input-Width" size="small" v-model="SNAT.extra" clearable></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span class="redirect-Tips">{{$t('lang.firewall.additonalParametersTips')}}</span>
                </el-col>
              </el-row>
            </el-form-item>
        </el-form>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">{{$t('lang.ConfigSetting.cancel')}}</el-button>
        <el-button size="small" type="danger" @click="editRedirect">{{$t('lang.ConfigSetting.SaveApply')}}</el-button>
      </div>
    </el-dialog>
   
  </div>
</template>
<script>
import SelectInput from '../../SelectInput/index'
import { cloneDeep, isEqual} from 'lodash'
import { updateConfig} from "@/api/configurationlist";
export default {
  props: ['IpList', "deviceDid", "deviceSn"],
  components: {
    SelectInput,
  },
  data() {
    return {
      dialogVisible: false,
      SNAT: {
        enabled: false,
        name: '',
        proto: '',
        src: '',
        src_ip: '',
        src_dip: '',
        dest_ip: '',
        dest: '',
        extra: ''
      },
      protoOptions: [
        { value: "TCP", label: this.$t("lang.ConfigSetting.TCP") },
        { value: "UDP", label: this.$t("lang.ConfigSetting.UDP") },
        { value: "tcp udp", label: this.$t("lang.ConfigSetting.TCP_UDP") },
        { value: "ICMP", label: this.$t("lang.ConfigSetting.ICMP") },
        { value: "all", label: 'All protocals' },
        { value: this.$t("lang.ConfigSetting.custom"), label: this.$t("lang.ConfigSetting.custom") },
      ],
      SRCOptions: [
        { value: "wan", label: "wan" },
        { value: "lan", label: "lan" },
        { value: "", label: this.$t("lang.ConfigSetting.anyoneDest") }
      ],
      index: 0,
      protoCustom: false, // 自定义proto
      originalData: {}
    }
  },
  methods: {
    show(item, index) {
      this.dialogVisible = true
      this.index = index
      this.SNAT =cloneDeep(item.options) 
      this.originalData = cloneDeep(this.SNAT)
      console.log(this.SNAT);
    },
    // 获取下拉框返回的值并更新到通信规则相应的数据中。
    IpSelectInput(props,index){
      this.SNAT[`${index[0]}`] = props
    },
    // 协议选择发生变化
    protoChange(value) {
      if(value === this.$t("lang.ConfigSetting.custom")) {
        this.protoCustom = true
        this.$nextTick(() => {
          this.$refs.proto.focus()
        }) 
      }else{
        this.protoCustom = false
      }
    },
    // 协议输入框失去焦点
    protoBlur() {
      this.protoCustom = false
    },
    //启用禁用
    OnOff(){
      this.SNAT.enabled=this.SNAT.enabled==''?true:false
    },
    
    editRedirect(){
      if(!isEqual(this.originalData, this.SNAT)) {
        // 0是禁用，其他的是开启
        let dataCopy = cloneDeep(this.SNAT)
        dataCopy.enabled = dataCopy.enabled == true ? '1' : '0'
        let data=[
          {section: "redirect",config: "firewall",action:0,index:[this.index],server: "firewall",options:{...dataCopy}}
        ]
        updateConfig(this.deviceSn,this.deviceDid,data).then((res)=>{
          if(res.data.data.mess===0){
            this.$message({
              showClose: true,
              message: this.$t('lang.ConfigSetting.Successfulconfiguration'),
              type: 'success'
            });
            this.$emit('updateData')
            this.dialogVisible = false
          }else {
            this.$message({
              showClose: true,
              message: this.$t('lang.ConfigSetting.Configurationerror'),
              type: 'warning'
            });
          }
        })
      }else{
        this.dialogVisible = false
      }
      
    },
  }
}
</script>
<style scoped>
.Form >>> .el-form-item__content{
  line-height: 20px !important;
}
.Form-Input-Width{
  width: 4rem;
}
.Form{
  display: flex;
  justify-content: center;
}
.redirect-Tips{
  color: rgb(158, 154, 154);
}
</style>